import { Directive, ElementRef, HostListener, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appValidNumber]'
})
export class ValidNumberDirective {

  regexStr = '^[0-9\.]*$';
  @Input() isAlphaNumeric: boolean;

  constructor(private el: ElementRef, @Optional() @Self() private ngControl: NgControl) { }


  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  @HostListener('input')
  onInput() {
    this.sanitizeAndSync();
  }

  @HostListener('paste')
  onPaste() {
    setTimeout(() => this.sanitizeAndSync(), 0);
  }

  private sanitizeAndSync() {
    const currentValue = (this.el.nativeElement.value || '').toString();
    const sanitizedValue = this.getSanitizedValue(currentValue);
    if (currentValue === sanitizedValue) {
      return;
    }

    this.el.nativeElement.value = sanitizedValue;
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(sanitizedValue, { emitEvent: false });
    }
  }

  private getSanitizedValue(value: string): string {
    let sanitized = value.replace(/\s+/g, '').replace(/[^0-9.]/g, '');
    const decimalIndex = sanitized.indexOf('.');
    if (decimalIndex !== -1) {
      const integerPart = sanitized.slice(0, decimalIndex);
      const decimalPart = sanitized.slice(decimalIndex + 1).replace(/\./g, '').slice(0, 2);
      sanitized = `${integerPart}.${decimalPart}`;
    }
    return sanitized;
  }
}
